// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EstateTaxScenarios_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, kind: Types.TestamentaryEntityKind, displayName: string };

export type EstateTaxScenarios_EntityFragment = { __typename?: 'Entity', id: string, extendedDisplayKind: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment = { __typename?: 'AISuggestion', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment = { __typename?: 'AISuggestionEvidence', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment = { __typename?: 'AccessAgeParameter', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment = { __typename?: 'AccessParameter', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Account_Fragment = { __typename?: 'Account', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment = { __typename?: 'ActiveEstateInsightsPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment = { __typename?: 'Activity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Address_Fragment = { __typename?: 'Address', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment = { __typename?: 'Answer', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment = { __typename?: 'AnswerEvidence', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment = { __typename?: 'AnswerRevision', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment = { __typename?: 'Approval', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment = { __typename?: 'AssetClass', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment = { __typename?: 'AssetGroup', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment = { __typename?: 'AssetStatic', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment = { __typename?: 'AssetV2', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment = { __typename?: 'AssetValuationV2', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment = { __typename?: 'AssetValueV2', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment = { __typename?: 'AsyncJob', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment = { __typename?: 'BalanceSheetBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment = { __typename?: 'BalanceSheetCategory', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment = { __typename?: 'BalanceSheetViewConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment = { __typename?: 'BeneficiariesBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment = { __typename?: 'BeneficiariesTemplateBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment = { __typename?: 'Beneficiary', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment = { __typename?: 'BeneficiaryAccessParameter', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment = { __typename?: 'BeneficiaryDesignationGroup', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment = { __typename?: 'BeneficiaryDistribution', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment = { __typename?: 'BeneficiaryDistributionParameter', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment = { __typename?: 'BeneficiaryPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment = { __typename?: 'BeneficiaryPowerOfAppointment', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment = { __typename?: 'CCorpBusinessEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment = { __typename?: 'CLTProposal', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment = { __typename?: 'CLTTrust', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment = { __typename?: 'CRTProposal', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment = { __typename?: 'CRTTrust', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment = { __typename?: 'Capability', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment = { __typename?: 'Cashflow', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment = { __typename?: 'ClientOrganization', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment = { __typename?: 'ClientPresentationV2', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment = { __typename?: 'ClientProfile', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment = { __typename?: 'ClientProfileRelationship', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment = { __typename?: 'Collaborator', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment = { __typename?: 'ComparedWaterfall', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment = { __typename?: 'CompletedEstateInsightsPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment = { __typename?: 'ControllingParty', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment = { __typename?: 'Conversation', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment = { __typename?: 'CoverPageConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment = { __typename?: 'CustodialPersonalAccount', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment = { __typename?: 'DSUEPortability', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment = { __typename?: 'DiagramArtifact', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment = { __typename?: 'DiagramArtifactPrompt', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment = { __typename?: 'DispositionScenario', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment = { __typename?: 'DispositiveProvision', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment = { __typename?: 'DispositiveProvisionTemplate', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment = { __typename?: 'DividerBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment = { __typename?: 'DividerTemplateBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Document_Fragment = { __typename?: 'Document', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment = { __typename?: 'DocumentQuestion', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment = { __typename?: 'DocumentQuestionAnswers', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment = { __typename?: 'DocumentSummary', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment = { __typename?: 'DocumentSummaryPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment = { __typename?: 'DocumentSummaryPrompt', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment = { __typename?: 'DocumentSummaryPromptTestRun', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment = { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment = { __typename?: 'DonorAdvisedFund', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment = { __typename?: 'Employee', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment = { __typename?: 'EntitiesOverviewBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment = { __typename?: 'EntitiesOverviewBundleConfigurationEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment = { __typename?: 'Entity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment = { __typename?: 'EntityDiagram', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment = { __typename?: 'EntityDocumentRelationship', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment = { __typename?: 'EntityGraphView', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment = { __typename?: 'EntityGraphViewBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment = { __typename?: 'EntityNotes', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment = { __typename?: 'EntityProposal', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment = { __typename?: 'EntitySummaryBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment = { __typename?: 'EntitySummaryTemplateBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment = { __typename?: 'EntityTask', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment = { __typename?: 'EntityTaxInfo', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment = { __typename?: 'EstateInsight', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment = { __typename?: 'EstateInsightReference', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment = { __typename?: 'EstateInsightsBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment = { __typename?: 'EstateTaxScenario', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment = { __typename?: 'EstateWaterfall', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment = { __typename?: 'EstateWaterfallHypotheticalStateChange', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment = { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment = { __typename?: 'EstateWaterfallMessageContext', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment = { __typename?: 'EstateWaterfallVisualizationConfig', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment = { __typename?: 'EstateWaterfallVisualizationFilter', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment = { __typename?: 'FamilyTreeBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment = { __typename?: 'FamilyTreeConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment = { __typename?: 'FeatureFlag', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment = { __typename?: 'FeatureFlagQueryRule', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_File_Fragment = { __typename?: 'File', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment = { __typename?: 'FilePage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment = { __typename?: 'FileParagraph', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Form_Fragment = { __typename?: 'Form', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment = { __typename?: 'FormVersion', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment = { __typename?: 'GPBusinessEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment = { __typename?: 'GRATAnnuityV2', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment = { __typename?: 'GRATProposalScenario', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment = { __typename?: 'GRATTrust', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment = { __typename?: 'GiftingProposal', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment = { __typename?: 'GiftingProposalCashFlow', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment = { __typename?: 'GiftingProposalGift', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment = { __typename?: 'GiftingProposalGiftSender', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment = { __typename?: 'GiftingProposalPortfolio', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment = { __typename?: 'GiftingProposalScenario', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment = { __typename?: 'GraphVisualizationGroup', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment = { __typename?: 'GrowthProfile', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment = { __typename?: 'GrowthProfileOverride', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Household_Fragment = { __typename?: 'Household', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment = { __typename?: 'HypotheticalCLT', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment = { __typename?: 'HypotheticalCRT', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment = { __typename?: 'HypotheticalGRAT', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment = { __typename?: 'HypotheticalInsurance', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment = { __typename?: 'HypotheticalSaleLoan', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment = { __typename?: 'HypotheticalTransferAsset', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment = { __typename?: 'HypotheticalTransferFundingSource', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment = { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment = { __typename?: 'ILITCrummeyLetter', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment = { __typename?: 'ILITTrust', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Image_Fragment = { __typename?: 'Image', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment = { __typename?: 'IncomeTaxPaymentConfig', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment = { __typename?: 'IndividualPersonalAccount', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment = { __typename?: 'InferredField', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment = { __typename?: 'InferredFieldEvidence', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment = { __typename?: 'InsightsTemplateBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment = { __typename?: 'InsurancePersonalAccount', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment = { __typename?: 'InsurancePolicy', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment = { __typename?: 'InsurancePremiumPayment', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment = { __typename?: 'IntegrationAssetClass', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment = { __typename?: 'IntegrationCashflow', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment = { __typename?: 'IntegrationClient', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment = { __typename?: 'IntegrationConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment = { __typename?: 'IntegrationEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment = { __typename?: 'IntegrationInsurance', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment = { __typename?: 'IntegrationLiability', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment = { __typename?: 'IntegrationPerson', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment = { __typename?: 'IrrevocableTrust', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment = { __typename?: 'JointPersonalAccount', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment = { __typename?: 'KGNode', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment = { __typename?: 'KGRelationship', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment = { __typename?: 'KGRoot', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment = { __typename?: 'KGV2Document', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment = { __typename?: 'KGV2DocumentChange', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment = { __typename?: 'KGV2DocumentModification', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment = { __typename?: 'KGV2Graph', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment = { __typename?: 'KGV2Node', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment = { __typename?: 'KGV2NodeAlias', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment = { __typename?: 'KGV2NodeEvidence', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment = { __typename?: 'KGV2Statement', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment = { __typename?: 'KGV2StatementEvidence', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment = { __typename?: 'KGV2StatementSupersession', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment = { __typename?: 'KeyPerson', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment = { __typename?: 'KeyPersonRole', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment = { __typename?: 'LLCBusinessEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment = { __typename?: 'LPBusinessEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment = { __typename?: 'LiabilitiesBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment = { __typename?: 'Liability', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment = { __typename?: 'LiabilityPayment', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment = { __typename?: 'LifeInsuranceBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment = { __typename?: 'LifetimeExclusionEvent', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment = { __typename?: 'LoggedTransfer', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment = { __typename?: 'LuminaryOrganization', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment = { __typename?: 'LuminaryTenantJIT', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment = { __typename?: 'ManagedSFTPConnection', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment = { __typename?: 'Memo', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment = { __typename?: 'MemoPrompt', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Message_Fragment = { __typename?: 'Message', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment = { __typename?: 'MissingDocumentOverride', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment = { __typename?: 'MissingDocumentsPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment = { __typename?: 'ModelMapping', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment = { __typename?: 'NotificationApp', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment = { __typename?: 'NotificationPreference', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment = { __typename?: 'OpenaiSdkConfig', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment = { __typename?: 'OrganizationApplicationConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment = { __typename?: 'OrganizationDisclaimerConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment = { __typename?: 'OwnershipStake', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment = { __typename?: 'PlatformDocument', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment = { __typename?: 'PlatformFile', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment = { __typename?: 'PlatformFilePage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment = { __typename?: 'PlatformFileParagraph', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment = { __typename?: 'PresentationApprovalRequest', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment = { __typename?: 'PresentationAssetDistributionBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment = { __typename?: 'PresentationAssetDistributionItemConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment = { __typename?: 'PresentationAssetDistributionItemDetail', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment = { __typename?: 'PresentationBundle', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment = { __typename?: 'PresentationBundleCoverPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment = { __typename?: 'PresentationBusinessOverviewBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment = { __typename?: 'PresentationBusinessOverviewBusinessConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment = { __typename?: 'PresentationBusinessOverviewItem', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment = { __typename?: 'PresentationCoverPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment = { __typename?: 'PresentationCoverSlideConfig', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment = { __typename?: 'PresentationCustomPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment = { __typename?: 'PresentationCustomPageBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment = { __typename?: 'PresentationDiagramPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment = { __typename?: 'PresentationDocumentsReviewedBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment = { __typename?: 'PresentationDocumentsReviewedDocument', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment = { __typename?: 'PresentationFamilyOverviewBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment = { __typename?: 'PresentationFamilyOverviewMemberConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment = { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment = { __typename?: 'PresentationHealthcareDirectiveClientConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment = { __typename?: 'PresentationHealthcareDirectiveItem', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment = { __typename?: 'PresentationItemCitation', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment = { __typename?: 'PresentationPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment = { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment = { __typename?: 'PresentationPlanningOpportunitiesItem', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment = { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment = { __typename?: 'PresentationPowerOfAttorneyClientConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment = { __typename?: 'PresentationPowerOfAttorneyItem', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment = { __typename?: 'PresentationTemplate', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment = { __typename?: 'PresentationTemplateBundle', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment = { __typename?: 'PresentationTemplateCoverPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment = { __typename?: 'PresentationTemplateCustomPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment = { __typename?: 'PresentationTemplateDiagramPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment = { __typename?: 'PresentationTemplatePage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment = { __typename?: 'PresentationTrustOverviewBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment = { __typename?: 'PresentationTrustOverviewItem', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment = { __typename?: 'PresentationTrustOverviewTrustConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment = { __typename?: 'PresentationWillBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment = { __typename?: 'PresentationWillClientConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment = { __typename?: 'PresentationWillItem', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment = { __typename?: 'Principal', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment = { __typename?: 'PrivateFoundation', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment = { __typename?: 'ProfessionalTeamRole', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment = { __typename?: 'Proposal', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment = { __typename?: 'ProposalScenario', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment = { __typename?: 'QPRTTrust', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment = { __typename?: 'QualifiedTuitionPersonalAccount', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment = { __typename?: 'ReleaseGroup', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment = { __typename?: 'ReminderEmailNotificationRecord', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment = { __typename?: 'RetirementPersonalAccount', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment = { __typename?: 'RevocableTrust', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Role_Fragment = { __typename?: 'Role', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment = { __typename?: 'SCorpBusinessEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment = { __typename?: 'SLATTrust', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment = { __typename?: 'SSOConnection', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment = { __typename?: 'SalesforceExportAttempt', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment = { __typename?: 'ScheduledDistribution', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment = { __typename?: 'SoleProprietorshipBusinessEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment = { __typename?: 'SubBrand', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment = { __typename?: 'SubBrandDisclaimerConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment = { __typename?: 'Submission', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment = { __typename?: 'TaxDragConfig', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment = { __typename?: 'TaxDragOverride', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Team_Fragment = { __typename?: 'Team', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment = { __typename?: 'Tenant', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment = { __typename?: 'TenantApplicationConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment = { __typename?: 'TenantBranding', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment = { __typename?: 'TenantDisclaimerConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment = { __typename?: 'TenantDocument', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment = { __typename?: 'TenantReminderEmailsConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment = { __typename?: 'TenantSSOConnection', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment = { __typename?: 'TenantSecurityConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment = { __typename?: 'TenantSlideConfig', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment = { __typename?: 'TestCMKEncryption', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment = { __typename?: 'TestamentaryEntity', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment = { __typename?: 'TrustAdvisor', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment = { __typename?: 'TrustAdvisorRole', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment = { __typename?: 'Trustee', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment = { __typename?: 'TrusteeDuty', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_User_Fragment = { __typename?: 'User', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment = { __typename?: 'UserFeedback', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment = { __typename?: 'UserNotificationConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment = { __typename?: 'WaterfallBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment = { __typename?: 'WaterfallBundleCoverPage', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment = { __typename?: 'WaterfallComparisonBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment = { __typename?: 'WaterfallComparisonTemplateBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment = { __typename?: 'WaterfallTemplateBundleConfiguration', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment = { __typename?: 'WorkOSOrganization', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment = { __typename?: 'WorkOSOrganizationDomain', id: string };

export type EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment = { __typename?: 'WorkflowTracker', id: string };

export type EstateTaxScenarios_PayoutOrderEntityFragment = EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment | EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment | EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment | EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment | EstateTaxScenarios_PayoutOrderEntity_Account_Fragment | EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment | EstateTaxScenarios_PayoutOrderEntity_Address_Fragment | EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment | EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment | EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment | EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment | EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment | EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment | EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment | EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment | EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment | EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment | EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment | EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment | EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment | EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment | EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment | EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment | EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment | EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment | EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment | EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment | EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment | EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment | EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment | EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment | EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment | EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment | EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment | EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment | EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment | EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment | EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment | EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment | EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment | EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment | EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment | EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment | EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment | EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment | EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment | EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_Document_Fragment | EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment | EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment | EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment | EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment | EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment | EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment | EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment | EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment | EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment | EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment | EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment | EstateTaxScenarios_PayoutOrderEntity_File_Fragment | EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment | EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment | EstateTaxScenarios_PayoutOrderEntity_Form_Fragment | EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment | EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment | EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment | EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment | EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment | EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment | EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment | EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment | EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment | EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment | EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment | EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment | EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment | EstateTaxScenarios_PayoutOrderEntity_Household_Fragment | EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment | EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment | EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment | EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment | EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment | EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment | EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment | EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment | EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment | EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment | EstateTaxScenarios_PayoutOrderEntity_Image_Fragment | EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment | EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment | EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment | EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment | EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment | EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment | EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment | EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment | EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment | EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment | EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment | EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment | EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment | EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment | EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment | EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment | EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment | EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment | EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment | EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment | EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment | EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment | EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment | EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment | EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment | EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment | EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment | EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment | EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment | EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment | EstateTaxScenarios_PayoutOrderEntity_Message_Fragment | EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment | EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment | EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment | EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment | EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment | EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment | EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment | EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment | EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment | EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment | EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment | EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment | EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment | EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment | EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment | EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment | EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment | EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment | EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment | EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment | EstateTaxScenarios_PayoutOrderEntity_Role_Fragment | EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment | EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment | EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment | EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment | EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment | EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment | EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment | EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment | EstateTaxScenarios_PayoutOrderEntity_Team_Fragment | EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment | EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment | EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment | EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment | EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment | EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment | EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment | EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment | EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment | EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment | EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment | EstateTaxScenarios_PayoutOrderEntity_User_Fragment | EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment | EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment | EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment | EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment | EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment | EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment;

export type EstateTaxScenarios_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, remainingGSTExclusion: CurrencyUSD, lifetimeExclusionUsed: CurrencyUSD, remainingStateExemption: CurrencyUSD, displayName: string, address?: { __typename?: 'Address', id: string, stateCode: string } | null, dsue?: { __typename?: 'DSUEPortability', id: string, amount: CurrencyUSD } | null };

export type EstateTaxScenarios_EstateTaxScenarioFragment = { __typename?: 'EstateTaxScenario', id: string, payoutKind: Types.EstateTaxScenarioPayoutKind, isExemptionPortable: boolean, displayName: string, firstGrantorDeath: { __typename?: 'ClientProfile', id: string }, firstDeathPayoutOrderMissingEntities: Array<(
    { __typename?: 'AISuggestion' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & EstateTaxScenarios_PayoutOrderEntity_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & EstateTaxScenarios_PayoutOrderEntity_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & EstateTaxScenarios_PayoutOrderEntity_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & EstateTaxScenarios_PayoutOrderEntity_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & EstateTaxScenarios_PayoutOrderEntity_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & EstateTaxScenarios_PayoutOrderEntity_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & EstateTaxScenarios_PayoutOrderEntity_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & EstateTaxScenarios_PayoutOrderEntity_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & EstateTaxScenarios_PayoutOrderEntity_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & EstateTaxScenarios_PayoutOrderEntity_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment
  )>, firstDeathPayoutOrder: Array<(
    { __typename?: 'AISuggestion' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & EstateTaxScenarios_PayoutOrderEntity_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & EstateTaxScenarios_PayoutOrderEntity_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & EstateTaxScenarios_PayoutOrderEntity_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & EstateTaxScenarios_PayoutOrderEntity_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & EstateTaxScenarios_PayoutOrderEntity_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & EstateTaxScenarios_PayoutOrderEntity_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & EstateTaxScenarios_PayoutOrderEntity_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & EstateTaxScenarios_PayoutOrderEntity_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & EstateTaxScenarios_PayoutOrderEntity_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & EstateTaxScenarios_PayoutOrderEntity_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment
  )>, secondDeathPayoutOrder?: Array<(
    { __typename?: 'AISuggestion' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & EstateTaxScenarios_PayoutOrderEntity_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & EstateTaxScenarios_PayoutOrderEntity_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & EstateTaxScenarios_PayoutOrderEntity_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & EstateTaxScenarios_PayoutOrderEntity_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & EstateTaxScenarios_PayoutOrderEntity_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & EstateTaxScenarios_PayoutOrderEntity_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & EstateTaxScenarios_PayoutOrderEntity_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & EstateTaxScenarios_PayoutOrderEntity_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & EstateTaxScenarios_PayoutOrderEntity_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & EstateTaxScenarios_PayoutOrderEntity_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment
  )> | null, secondDeathPayoutOrderMissingEntities?: Array<(
    { __typename?: 'AISuggestion' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & EstateTaxScenarios_PayoutOrderEntity_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & EstateTaxScenarios_PayoutOrderEntity_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & EstateTaxScenarios_PayoutOrderEntity_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & EstateTaxScenarios_PayoutOrderEntity_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & EstateTaxScenarios_PayoutOrderEntity_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & EstateTaxScenarios_PayoutOrderEntity_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & EstateTaxScenarios_PayoutOrderEntity_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & EstateTaxScenarios_PayoutOrderEntity_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & EstateTaxScenarios_PayoutOrderEntity_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & EstateTaxScenarios_PayoutOrderEntity_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment
  )> | null };

export type EstateTaxScenarios_HouseholdFragment = { __typename?: 'Household', id: string, estateTaxScenarios?: Array<(
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_EstateTaxScenarioFragment
  )> | null, possiblePrimaryClients: Array<(
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_ClientProfileFragment
  )>, testamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
        { __typename?: 'TestamentaryEntity' }
        & EstateTaxScenarios_TestamentaryEntityFragment
      ) | null } | null> | null }, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & EstateTaxScenarios_EntityFragment
      ) | null } | null> | null } };

export type EstateTaxScenariosQueryVariables = Types.Exact<{
  where: Types.HouseholdWhereInput;
  firstGrantorFirstPayout: Types.EstateTaxScenarioPossibleEntitiesInput;
  firstGrantorSecondPayout: Types.EstateTaxScenarioPossibleEntitiesInput;
  secondGrantorFirstPayout: Types.EstateTaxScenarioPossibleEntitiesInput;
  secondGrantorSecondPayout: Types.EstateTaxScenarioPossibleEntitiesInput;
  isTwoGrantorClient: Types.Scalars['Boolean']['input'];
}>;


export type EstateTaxScenariosQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & EstateTaxScenarios_HouseholdFragment
      ) | null } | null> | null }, firstGrantorFirstPayout: Array<(
    { __typename?: 'AISuggestion' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & EstateTaxScenarios_PayoutOrderEntity_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & EstateTaxScenarios_PayoutOrderEntity_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & EstateTaxScenarios_PayoutOrderEntity_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & EstateTaxScenarios_PayoutOrderEntity_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & EstateTaxScenarios_PayoutOrderEntity_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & EstateTaxScenarios_PayoutOrderEntity_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & EstateTaxScenarios_PayoutOrderEntity_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & EstateTaxScenarios_PayoutOrderEntity_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & EstateTaxScenarios_PayoutOrderEntity_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & EstateTaxScenarios_PayoutOrderEntity_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment
  )>, firstGrantorSecondPayout?: Array<(
    { __typename?: 'AISuggestion' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & EstateTaxScenarios_PayoutOrderEntity_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & EstateTaxScenarios_PayoutOrderEntity_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & EstateTaxScenarios_PayoutOrderEntity_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & EstateTaxScenarios_PayoutOrderEntity_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & EstateTaxScenarios_PayoutOrderEntity_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & EstateTaxScenarios_PayoutOrderEntity_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & EstateTaxScenarios_PayoutOrderEntity_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & EstateTaxScenarios_PayoutOrderEntity_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & EstateTaxScenarios_PayoutOrderEntity_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & EstateTaxScenarios_PayoutOrderEntity_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment
  )>, secondGrantorFirstPayout?: Array<(
    { __typename?: 'AISuggestion' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & EstateTaxScenarios_PayoutOrderEntity_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & EstateTaxScenarios_PayoutOrderEntity_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & EstateTaxScenarios_PayoutOrderEntity_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & EstateTaxScenarios_PayoutOrderEntity_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & EstateTaxScenarios_PayoutOrderEntity_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & EstateTaxScenarios_PayoutOrderEntity_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & EstateTaxScenarios_PayoutOrderEntity_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & EstateTaxScenarios_PayoutOrderEntity_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & EstateTaxScenarios_PayoutOrderEntity_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & EstateTaxScenarios_PayoutOrderEntity_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment
  )>, secondGrantorSecondPayout?: Array<(
    { __typename?: 'AISuggestion' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestion_Fragment
  ) | (
    { __typename?: 'AISuggestionEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AiSuggestionEvidence_Fragment
  ) | (
    { __typename?: 'AccessAgeParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessAgeParameter_Fragment
  ) | (
    { __typename?: 'AccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_AccessParameter_Fragment
  ) | (
    { __typename?: 'Account' }
    & EstateTaxScenarios_PayoutOrderEntity_Account_Fragment
  ) | (
    { __typename?: 'ActiveEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_ActiveEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'Activity' }
    & EstateTaxScenarios_PayoutOrderEntity_Activity_Fragment
  ) | (
    { __typename?: 'Address' }
    & EstateTaxScenarios_PayoutOrderEntity_Address_Fragment
  ) | (
    { __typename?: 'Answer' }
    & EstateTaxScenarios_PayoutOrderEntity_Answer_Fragment
  ) | (
    { __typename?: 'AnswerEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerEvidence_Fragment
  ) | (
    { __typename?: 'AnswerRevision' }
    & EstateTaxScenarios_PayoutOrderEntity_AnswerRevision_Fragment
  ) | (
    { __typename?: 'Approval' }
    & EstateTaxScenarios_PayoutOrderEntity_Approval_Fragment
  ) | (
    { __typename?: 'AssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetClass_Fragment
  ) | (
    { __typename?: 'AssetGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetGroup_Fragment
  ) | (
    { __typename?: 'AssetStatic' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetStatic_Fragment
  ) | (
    { __typename?: 'AssetV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetV2_Fragment
  ) | (
    { __typename?: 'AssetValuationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValuationV2_Fragment
  ) | (
    { __typename?: 'AssetValueV2' }
    & EstateTaxScenarios_PayoutOrderEntity_AssetValueV2_Fragment
  ) | (
    { __typename?: 'AsyncJob' }
    & EstateTaxScenarios_PayoutOrderEntity_AsyncJob_Fragment
  ) | (
    { __typename?: 'BalanceSheetBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BalanceSheetCategory' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetCategory_Fragment
  ) | (
    { __typename?: 'BalanceSheetViewConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BalanceSheetViewConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'BeneficiariesTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiariesTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Beneficiary' }
    & EstateTaxScenarios_PayoutOrderEntity_Beneficiary_Fragment
  ) | (
    { __typename?: 'BeneficiaryAccessParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryAccessParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryDesignationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDesignationGroup_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistribution_Fragment
  ) | (
    { __typename?: 'BeneficiaryDistributionParameter' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryDistributionParameter_Fragment
  ) | (
    { __typename?: 'BeneficiaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPage_Fragment
  ) | (
    { __typename?: 'BeneficiaryPowerOfAppointment' }
    & EstateTaxScenarios_PayoutOrderEntity_BeneficiaryPowerOfAppointment_Fragment
  ) | (
    { __typename?: 'CCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CltProposal_Fragment
  ) | (
    { __typename?: 'CLTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CltTrust_Fragment
  ) | (
    { __typename?: 'CRTProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtProposal_Fragment
  ) | (
    { __typename?: 'CRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_CrtTrust_Fragment
  ) | (
    { __typename?: 'Capability' }
    & EstateTaxScenarios_PayoutOrderEntity_Capability_Fragment
  ) | (
    { __typename?: 'Cashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_Cashflow_Fragment
  ) | (
    { __typename?: 'ClientOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientOrganization_Fragment
  ) | (
    { __typename?: 'ClientPresentationV2' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientPresentationV2_Fragment
  ) | (
    { __typename?: 'ClientProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfile_Fragment
  ) | (
    { __typename?: 'ClientProfileRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_ClientProfileRelationship_Fragment
  ) | (
    { __typename?: 'Collaborator' }
    & EstateTaxScenarios_PayoutOrderEntity_Collaborator_Fragment
  ) | (
    { __typename?: 'ComparedWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_ComparedWaterfall_Fragment
  ) | (
    { __typename?: 'CompletedEstateInsightsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_CompletedEstateInsightsPage_Fragment
  ) | (
    { __typename?: 'ControllingParty' }
    & EstateTaxScenarios_PayoutOrderEntity_ControllingParty_Fragment
  ) | (
    { __typename?: 'Conversation' }
    & EstateTaxScenarios_PayoutOrderEntity_Conversation_Fragment
  ) | (
    { __typename?: 'CoverPageConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_CoverPageConfiguration_Fragment
  ) | (
    { __typename?: 'CustodialPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_CustodialPersonalAccount_Fragment
  ) | (
    { __typename?: 'DSUEPortability' }
    & EstateTaxScenarios_PayoutOrderEntity_DsuePortability_Fragment
  ) | (
    { __typename?: 'DiagramArtifact' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifact_Fragment
  ) | (
    { __typename?: 'DiagramArtifactPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DiagramArtifactPrompt_Fragment
  ) | (
    { __typename?: 'DispositionScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositionScenario_Fragment
  ) | (
    { __typename?: 'DispositiveProvision' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvision_Fragment
  ) | (
    { __typename?: 'DispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_DispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'DividerBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DividerTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DividerTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Document_Fragment
  ) | (
    { __typename?: 'DocumentQuestion' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestion_Fragment
  ) | (
    { __typename?: 'DocumentQuestionAnswers' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentQuestionAnswers_Fragment
  ) | (
    { __typename?: 'DocumentSummary' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummary_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPage' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPage_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPrompt_Fragment
  ) | (
    { __typename?: 'DocumentSummaryPromptTestRun' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryPromptTestRun_Fragment
  ) | (
    { __typename?: 'DocumentSummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_DocumentSummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'DonorAdvisedFund' }
    & EstateTaxScenarios_PayoutOrderEntity_DonorAdvisedFund_Fragment
  ) | (
    { __typename?: 'Employee' }
    & EstateTaxScenarios_PayoutOrderEntity_Employee_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitiesOverviewBundleConfigurationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitiesOverviewBundleConfigurationEntity_Fragment
  ) | (
    { __typename?: 'Entity' }
    & EstateTaxScenarios_PayoutOrderEntity_Entity_Fragment
  ) | (
    { __typename?: 'EntityDiagram' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDiagram_Fragment
  ) | (
    { __typename?: 'EntityDocumentRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityDocumentRelationship_Fragment
  ) | (
    { __typename?: 'EntityGraphView' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphView_Fragment
  ) | (
    { __typename?: 'EntityGraphViewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityGraphViewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityNotes' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityNotes_Fragment
  ) | (
    { __typename?: 'EntityProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityProposal_Fragment
  ) | (
    { __typename?: 'EntitySummaryBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntitySummaryTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EntitySummaryTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EntityTask' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTask_Fragment
  ) | (
    { __typename?: 'EntityTaxInfo' }
    & EstateTaxScenarios_PayoutOrderEntity_EntityTaxInfo_Fragment
  ) | (
    { __typename?: 'EstateInsight' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsight_Fragment
  ) | (
    { __typename?: 'EstateInsightReference' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightReference_Fragment
  ) | (
    { __typename?: 'EstateInsightsBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateInsightsBundleConfiguration_Fragment
  ) | (
    { __typename?: 'EstateTaxScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateTaxScenario_Fragment
  ) | (
    { __typename?: 'EstateWaterfall' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfall_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalStateChange' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalStateChange_Fragment
  ) | (
    { __typename?: 'EstateWaterfallHypotheticalTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallHypotheticalTransfer_Fragment
  ) | (
    { __typename?: 'EstateWaterfallMessageContext' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallMessageContext_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationConfig_Fragment
  ) | (
    { __typename?: 'EstateWaterfallVisualizationFilter' }
    & EstateTaxScenarios_PayoutOrderEntity_EstateWaterfallVisualizationFilter_Fragment
  ) | (
    { __typename?: 'FamilyTreeBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeBundleConfiguration_Fragment
  ) | (
    { __typename?: 'FamilyTreeConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_FamilyTreeConfiguration_Fragment
  ) | (
    { __typename?: 'FeatureFlag' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlag_Fragment
  ) | (
    { __typename?: 'FeatureFlagQueryRule' }
    & EstateTaxScenarios_PayoutOrderEntity_FeatureFlagQueryRule_Fragment
  ) | (
    { __typename?: 'File' }
    & EstateTaxScenarios_PayoutOrderEntity_File_Fragment
  ) | (
    { __typename?: 'FilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_FilePage_Fragment
  ) | (
    { __typename?: 'FileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_FileParagraph_Fragment
  ) | (
    { __typename?: 'Form' }
    & EstateTaxScenarios_PayoutOrderEntity_Form_Fragment
  ) | (
    { __typename?: 'FormVersion' }
    & EstateTaxScenarios_PayoutOrderEntity_FormVersion_Fragment
  ) | (
    { __typename?: 'GPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATAnnuityV2' }
    & EstateTaxScenarios_PayoutOrderEntity_GratAnnuityV2_Fragment
  ) | (
    { __typename?: 'GRATProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GratProposalScenario_Fragment
  ) | (
    { __typename?: 'GRATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_GratTrust_Fragment
  ) | (
    { __typename?: 'GiftingProposal' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposal_Fragment
  ) | (
    { __typename?: 'GiftingProposalCashFlow' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalCashFlow_Fragment
  ) | (
    { __typename?: 'GiftingProposalGift' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGift_Fragment
  ) | (
    { __typename?: 'GiftingProposalGiftSender' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalGiftSender_Fragment
  ) | (
    { __typename?: 'GiftingProposalPortfolio' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalPortfolio_Fragment
  ) | (
    { __typename?: 'GiftingProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_GiftingProposalScenario_Fragment
  ) | (
    { __typename?: 'GraphVisualizationGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_GraphVisualizationGroup_Fragment
  ) | (
    { __typename?: 'GrowthProfile' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfile_Fragment
  ) | (
    { __typename?: 'GrowthProfileOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_GrowthProfileOverride_Fragment
  ) | (
    { __typename?: 'Household' }
    & EstateTaxScenarios_PayoutOrderEntity_Household_Fragment
  ) | (
    { __typename?: 'HypotheticalCLT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalClt_Fragment
  ) | (
    { __typename?: 'HypotheticalCRT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalCrt_Fragment
  ) | (
    { __typename?: 'HypotheticalGRAT' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalGrat_Fragment
  ) | (
    { __typename?: 'HypotheticalInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalInsurance_Fragment
  ) | (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalSaleLoan_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferAsset' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferAsset_Fragment
  ) | (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalTransferFundingSource_Fragment
  ) | (
    { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_HypotheticalWaterfallDispositiveProvisionTemplate_Fragment
  ) | (
    { __typename?: 'ILITCrummeyLetter' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitCrummeyLetter_Fragment
  ) | (
    { __typename?: 'ILITTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IlitTrust_Fragment
  ) | (
    { __typename?: 'Image' }
    & EstateTaxScenarios_PayoutOrderEntity_Image_Fragment
  ) | (
    { __typename?: 'IncomeTaxPaymentConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_IncomeTaxPaymentConfig_Fragment
  ) | (
    { __typename?: 'IndividualPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_IndividualPersonalAccount_Fragment
  ) | (
    { __typename?: 'InferredField' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredField_Fragment
  ) | (
    { __typename?: 'InferredFieldEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_InferredFieldEvidence_Fragment
  ) | (
    { __typename?: 'InsightsTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_InsightsTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'InsurancePersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePersonalAccount_Fragment
  ) | (
    { __typename?: 'InsurancePolicy' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePolicy_Fragment
  ) | (
    { __typename?: 'InsurancePremiumPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_InsurancePremiumPayment_Fragment
  ) | (
    { __typename?: 'IntegrationAssetClass' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationAssetClass_Fragment
  ) | (
    { __typename?: 'IntegrationCashflow' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationCashflow_Fragment
  ) | (
    { __typename?: 'IntegrationClient' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationClient_Fragment
  ) | (
    { __typename?: 'IntegrationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationConfiguration_Fragment
  ) | (
    { __typename?: 'IntegrationEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationEntity_Fragment
  ) | (
    { __typename?: 'IntegrationInsurance' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationInsurance_Fragment
  ) | (
    { __typename?: 'IntegrationLiability' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationLiability_Fragment
  ) | (
    { __typename?: 'IntegrationPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_IntegrationPerson_Fragment
  ) | (
    { __typename?: 'IrrevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_IrrevocableTrust_Fragment
  ) | (
    { __typename?: 'JointPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_JointPersonalAccount_Fragment
  ) | (
    { __typename?: 'KGNode' }
    & EstateTaxScenarios_PayoutOrderEntity_KgNode_Fragment
  ) | (
    { __typename?: 'KGRelationship' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRelationship_Fragment
  ) | (
    { __typename?: 'KGRoot' }
    & EstateTaxScenarios_PayoutOrderEntity_KgRoot_Fragment
  ) | (
    { __typename?: 'KGV2Document' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Document_Fragment
  ) | (
    { __typename?: 'KGV2DocumentChange' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentChange_Fragment
  ) | (
    { __typename?: 'KGV2DocumentModification' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2DocumentModification_Fragment
  ) | (
    { __typename?: 'KGV2Graph' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Graph_Fragment
  ) | (
    { __typename?: 'KGV2Node' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Node_Fragment
  ) | (
    { __typename?: 'KGV2NodeAlias' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeAlias_Fragment
  ) | (
    { __typename?: 'KGV2NodeEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2NodeEvidence_Fragment
  ) | (
    { __typename?: 'KGV2Statement' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2Statement_Fragment
  ) | (
    { __typename?: 'KGV2StatementEvidence' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementEvidence_Fragment
  ) | (
    { __typename?: 'KGV2StatementSupersession' }
    & EstateTaxScenarios_PayoutOrderEntity_Kgv2StatementSupersession_Fragment
  ) | (
    { __typename?: 'KeyPerson' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPerson_Fragment
  ) | (
    { __typename?: 'KeyPersonRole' }
    & EstateTaxScenarios_PayoutOrderEntity_KeyPersonRole_Fragment
  ) | (
    { __typename?: 'LLCBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'LiabilitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'Liability' }
    & EstateTaxScenarios_PayoutOrderEntity_Liability_Fragment
  ) | (
    { __typename?: 'LiabilityPayment' }
    & EstateTaxScenarios_PayoutOrderEntity_LiabilityPayment_Fragment
  ) | (
    { __typename?: 'LifeInsuranceBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_LifeInsuranceBundleConfiguration_Fragment
  ) | (
    { __typename?: 'LifetimeExclusionEvent' }
    & EstateTaxScenarios_PayoutOrderEntity_LifetimeExclusionEvent_Fragment
  ) | (
    { __typename?: 'LoggedTransfer' }
    & EstateTaxScenarios_PayoutOrderEntity_LoggedTransfer_Fragment
  ) | (
    { __typename?: 'LuminaryOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryOrganization_Fragment
  ) | (
    { __typename?: 'LuminaryTenantJIT' }
    & EstateTaxScenarios_PayoutOrderEntity_LuminaryTenantJit_Fragment
  ) | (
    { __typename?: 'ManagedSFTPConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_ManagedSftpConnection_Fragment
  ) | (
    { __typename?: 'Memo' }
    & EstateTaxScenarios_PayoutOrderEntity_Memo_Fragment
  ) | (
    { __typename?: 'MemoPrompt' }
    & EstateTaxScenarios_PayoutOrderEntity_MemoPrompt_Fragment
  ) | (
    { __typename?: 'Message' }
    & EstateTaxScenarios_PayoutOrderEntity_Message_Fragment
  ) | (
    { __typename?: 'MissingDocumentOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentOverride_Fragment
  ) | (
    { __typename?: 'MissingDocumentsPage' }
    & EstateTaxScenarios_PayoutOrderEntity_MissingDocumentsPage_Fragment
  ) | (
    { __typename?: 'ModelMapping' }
    & EstateTaxScenarios_PayoutOrderEntity_ModelMapping_Fragment
  ) | (
    { __typename?: 'NotificationApp' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationApp_Fragment
  ) | (
    { __typename?: 'NotificationPreference' }
    & EstateTaxScenarios_PayoutOrderEntity_NotificationPreference_Fragment
  ) | (
    { __typename?: 'OpenaiSdkConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_OpenaiSdkConfig_Fragment
  ) | (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_OrganizationDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'OwnershipStake' }
    & EstateTaxScenarios_PayoutOrderEntity_OwnershipStake_Fragment
  ) | (
    { __typename?: 'PlatformDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformDocument_Fragment
  ) | (
    { __typename?: 'PlatformFile' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFile_Fragment
  ) | (
    { __typename?: 'PlatformFilePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFilePage_Fragment
  ) | (
    { __typename?: 'PlatformFileParagraph' }
    & EstateTaxScenarios_PayoutOrderEntity_PlatformFileParagraph_Fragment
  ) | (
    { __typename?: 'PresentationApprovalRequest' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationApprovalRequest_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationAssetDistributionItemDetail' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationAssetDistributionItemDetail_Fragment
  ) | (
    { __typename?: 'PresentationBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundle_Fragment
  ) | (
    { __typename?: 'PresentationBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBundleCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewBusinessConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationBusinessOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationBusinessOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationCoverSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCoverSlideConfig_Fragment
  ) | (
    { __typename?: 'PresentationCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationCustomPageBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationCustomPageBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationDocumentsReviewedDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationDocumentsReviewedDocument_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationFamilyOverviewMemberConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationFamilyOverviewMemberConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationHealthcareDirectiveItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationHealthcareDirectiveItem_Fragment
  ) | (
    { __typename?: 'PresentationItemCitation' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationItemCitation_Fragment
  ) | (
    { __typename?: 'PresentationPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPage_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPlanningOpportunitiesItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPlanningOpportunitiesItem_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationPowerOfAttorneyItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationPowerOfAttorneyItem_Fragment
  ) | (
    { __typename?: 'PresentationTemplate' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplate_Fragment
  ) | (
    { __typename?: 'PresentationTemplateBundle' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateBundle_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCoverPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateCustomPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateCustomPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplateDiagramPage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplateDiagramPage_Fragment
  ) | (
    { __typename?: 'PresentationTemplatePage' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTemplatePage_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewItem_Fragment
  ) | (
    { __typename?: 'PresentationTrustOverviewTrustConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationTrustOverviewTrustConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillBundleConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillClientConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillClientConfiguration_Fragment
  ) | (
    { __typename?: 'PresentationWillItem' }
    & EstateTaxScenarios_PayoutOrderEntity_PresentationWillItem_Fragment
  ) | (
    { __typename?: 'Principal' }
    & EstateTaxScenarios_PayoutOrderEntity_Principal_Fragment
  ) | (
    { __typename?: 'PrivateFoundation' }
    & EstateTaxScenarios_PayoutOrderEntity_PrivateFoundation_Fragment
  ) | (
    { __typename?: 'ProfessionalTeamRole' }
    & EstateTaxScenarios_PayoutOrderEntity_ProfessionalTeamRole_Fragment
  ) | (
    { __typename?: 'Proposal' }
    & EstateTaxScenarios_PayoutOrderEntity_Proposal_Fragment
  ) | (
    { __typename?: 'ProposalScenario' }
    & EstateTaxScenarios_PayoutOrderEntity_ProposalScenario_Fragment
  ) | (
    { __typename?: 'QPRTTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_QprtTrust_Fragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_QualifiedTuitionPersonalAccount_Fragment
  ) | (
    { __typename?: 'ReleaseGroup' }
    & EstateTaxScenarios_PayoutOrderEntity_ReleaseGroup_Fragment
  ) | (
    { __typename?: 'ReminderEmailNotificationRecord' }
    & EstateTaxScenarios_PayoutOrderEntity_ReminderEmailNotificationRecord_Fragment
  ) | (
    { __typename?: 'RetirementPersonalAccount' }
    & EstateTaxScenarios_PayoutOrderEntity_RetirementPersonalAccount_Fragment
  ) | (
    { __typename?: 'RevocableTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_RevocableTrust_Fragment
  ) | (
    { __typename?: 'Role' }
    & EstateTaxScenarios_PayoutOrderEntity_Role_Fragment
  ) | (
    { __typename?: 'SCorpBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust' }
    & EstateTaxScenarios_PayoutOrderEntity_SlatTrust_Fragment
  ) | (
    { __typename?: 'SSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_SsoConnection_Fragment
  ) | (
    { __typename?: 'SalesforceExportAttempt' }
    & EstateTaxScenarios_PayoutOrderEntity_SalesforceExportAttempt_Fragment
  ) | (
    { __typename?: 'ScheduledDistribution' }
    & EstateTaxScenarios_PayoutOrderEntity_ScheduledDistribution_Fragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_SoleProprietorshipBusinessEntity_Fragment
  ) | (
    { __typename?: 'SubBrand' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrand_Fragment
  ) | (
    { __typename?: 'SubBrandDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_SubBrandDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'Submission' }
    & EstateTaxScenarios_PayoutOrderEntity_Submission_Fragment
  ) | (
    { __typename?: 'TaxDragConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragConfig_Fragment
  ) | (
    { __typename?: 'TaxDragOverride' }
    & EstateTaxScenarios_PayoutOrderEntity_TaxDragOverride_Fragment
  ) | (
    { __typename?: 'Team' }
    & EstateTaxScenarios_PayoutOrderEntity_Team_Fragment
  ) | (
    { __typename?: 'Tenant' }
    & EstateTaxScenarios_PayoutOrderEntity_Tenant_Fragment
  ) | (
    { __typename?: 'TenantApplicationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantApplicationConfiguration_Fragment
  ) | (
    { __typename?: 'TenantBranding' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantBranding_Fragment
  ) | (
    { __typename?: 'TenantDisclaimerConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDisclaimerConfiguration_Fragment
  ) | (
    { __typename?: 'TenantDocument' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantDocument_Fragment
  ) | (
    { __typename?: 'TenantReminderEmailsConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantReminderEmailsConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSSOConnection' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSsoConnection_Fragment
  ) | (
    { __typename?: 'TenantSecurityConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSecurityConfiguration_Fragment
  ) | (
    { __typename?: 'TenantSlideConfig' }
    & EstateTaxScenarios_PayoutOrderEntity_TenantSlideConfig_Fragment
  ) | (
    { __typename?: 'TestCMKEncryption' }
    & EstateTaxScenarios_PayoutOrderEntity_TestCmkEncryption_Fragment
  ) | (
    { __typename?: 'TestamentaryEntity' }
    & EstateTaxScenarios_PayoutOrderEntity_TestamentaryEntity_Fragment
  ) | (
    { __typename?: 'TrustAdvisor' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisor_Fragment
  ) | (
    { __typename?: 'TrustAdvisorRole' }
    & EstateTaxScenarios_PayoutOrderEntity_TrustAdvisorRole_Fragment
  ) | (
    { __typename?: 'Trustee' }
    & EstateTaxScenarios_PayoutOrderEntity_Trustee_Fragment
  ) | (
    { __typename?: 'TrusteeDuty' }
    & EstateTaxScenarios_PayoutOrderEntity_TrusteeDuty_Fragment
  ) | (
    { __typename?: 'User' }
    & EstateTaxScenarios_PayoutOrderEntity_User_Fragment
  ) | (
    { __typename?: 'UserFeedback' }
    & EstateTaxScenarios_PayoutOrderEntity_UserFeedback_Fragment
  ) | (
    { __typename?: 'UserNotificationConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_UserNotificationConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallBundleCoverPage' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallBundleCoverPage_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallComparisonTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WaterfallTemplateBundleConfiguration' }
    & EstateTaxScenarios_PayoutOrderEntity_WaterfallTemplateBundleConfiguration_Fragment
  ) | (
    { __typename?: 'WorkOSOrganization' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganization_Fragment
  ) | (
    { __typename?: 'WorkOSOrganizationDomain' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkOsOrganizationDomain_Fragment
  ) | (
    { __typename?: 'WorkflowTracker' }
    & EstateTaxScenarios_PayoutOrderEntity_WorkflowTracker_Fragment
  )> };

export type UpdateEstateTaxScenariosMutationVariables = Types.Exact<{
  inputs: Array<Types.InputMaybe<Types.AugmentedUpdateHouseholdInput>> | Types.InputMaybe<Types.AugmentedUpdateHouseholdInput>;
  clientProfileIDs: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type UpdateEstateTaxScenariosMutation = { __typename?: 'Mutation', deleteClientProfilesDsue: boolean, updateHouseholds: Array<(
    { __typename?: 'Household' }
    & EstateTaxScenarios_HouseholdFragment
  ) | null> };

export const Operations = {
  Query: {
    EstateTaxScenarios: 'EstateTaxScenarios' as const
  },
  Mutation: {
    UpdateEstateTaxScenarios: 'UpdateEstateTaxScenarios' as const
  },
  Fragment: {
    EstateTaxScenarios_TestamentaryEntity: 'EstateTaxScenarios_TestamentaryEntity' as const,
    EstateTaxScenarios_Entity: 'EstateTaxScenarios_Entity' as const,
    EstateTaxScenarios_PayoutOrderEntity: 'EstateTaxScenarios_PayoutOrderEntity' as const,
    EstateTaxScenarios_ClientProfile: 'EstateTaxScenarios_ClientProfile' as const,
    EstateTaxScenarios_EstateTaxScenario: 'EstateTaxScenarios_EstateTaxScenario' as const,
    EstateTaxScenarios_Household: 'EstateTaxScenarios_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateTaxScenarios_PayoutOrderEntityFragmentDoc = gql`
    fragment EstateTaxScenarios_PayoutOrderEntity on Node {
  id
}
    `;
export const EstateTaxScenarios_EstateTaxScenarioFragmentDoc = gql`
    fragment EstateTaxScenarios_EstateTaxScenario on EstateTaxScenario {
  id
  payoutKind
  isExemptionPortable
  displayName
  firstGrantorDeath {
    id
  }
  firstDeathPayoutOrderMissingEntities {
    ...EstateTaxScenarios_PayoutOrderEntity
  }
  firstDeathPayoutOrder {
    ...EstateTaxScenarios_PayoutOrderEntity
  }
  secondDeathPayoutOrder {
    ...EstateTaxScenarios_PayoutOrderEntity
  }
  secondDeathPayoutOrderMissingEntities {
    ...EstateTaxScenarios_PayoutOrderEntity
  }
}
    ${EstateTaxScenarios_PayoutOrderEntityFragmentDoc}`;
export const EstateTaxScenarios_ClientProfileFragmentDoc = gql`
    fragment EstateTaxScenarios_ClientProfile on ClientProfile {
  id
  remainingGSTExclusion
  lifetimeExclusionUsed
  remainingStateExemption
  displayName
  address {
    id
    stateCode
  }
  dsue {
    id
    amount
  }
}
    `;
export const EstateTaxScenarios_TestamentaryEntityFragmentDoc = gql`
    fragment EstateTaxScenarios_TestamentaryEntity on TestamentaryEntity {
  id
  kind
  displayName
}
    `;
export const EstateTaxScenarios_EntityFragmentDoc = gql`
    fragment EstateTaxScenarios_Entity on Entity {
  id
  extendedDisplayKind
  subtype {
    id
    displayName
  }
}
    `;
export const EstateTaxScenarios_HouseholdFragmentDoc = gql`
    fragment EstateTaxScenarios_Household on Household {
  id
  estateTaxScenarios {
    ...EstateTaxScenarios_EstateTaxScenario
  }
  possiblePrimaryClients {
    ...EstateTaxScenarios_ClientProfile
  }
  testamentaryEntities {
    edges {
      node {
        ...EstateTaxScenarios_TestamentaryEntity
      }
    }
  }
  entities {
    edges {
      node {
        ...EstateTaxScenarios_Entity
      }
    }
  }
}
    ${EstateTaxScenarios_EstateTaxScenarioFragmentDoc}
${EstateTaxScenarios_ClientProfileFragmentDoc}
${EstateTaxScenarios_TestamentaryEntityFragmentDoc}
${EstateTaxScenarios_EntityFragmentDoc}`;
export const EstateTaxScenariosDocument = gql`
    query EstateTaxScenarios($where: HouseholdWhereInput!, $firstGrantorFirstPayout: EstateTaxScenarioPossibleEntitiesInput!, $firstGrantorSecondPayout: EstateTaxScenarioPossibleEntitiesInput!, $secondGrantorFirstPayout: EstateTaxScenarioPossibleEntitiesInput!, $secondGrantorSecondPayout: EstateTaxScenarioPossibleEntitiesInput!, $isTwoGrantorClient: Boolean!) {
  households(where: $where) {
    edges {
      node {
        ...EstateTaxScenarios_Household
      }
    }
  }
  firstGrantorFirstPayout: estateTaxScenarioPossibleEntities(
    input: $firstGrantorFirstPayout
  ) {
    ...EstateTaxScenarios_PayoutOrderEntity
  }
  firstGrantorSecondPayout: estateTaxScenarioPossibleEntities(
    input: $firstGrantorSecondPayout
  ) @include(if: $isTwoGrantorClient) {
    ...EstateTaxScenarios_PayoutOrderEntity
  }
  secondGrantorFirstPayout: estateTaxScenarioPossibleEntities(
    input: $secondGrantorFirstPayout
  ) @include(if: $isTwoGrantorClient) {
    ...EstateTaxScenarios_PayoutOrderEntity
  }
  secondGrantorSecondPayout: estateTaxScenarioPossibleEntities(
    input: $secondGrantorSecondPayout
  ) @include(if: $isTwoGrantorClient) {
    ...EstateTaxScenarios_PayoutOrderEntity
  }
}
    ${EstateTaxScenarios_HouseholdFragmentDoc}
${EstateTaxScenarios_PayoutOrderEntityFragmentDoc}`;

/**
 * __useEstateTaxScenariosQuery__
 *
 * To run a query within a React component, call `useEstateTaxScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateTaxScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateTaxScenariosQuery({
 *   variables: {
 *      where: // value for 'where'
 *      firstGrantorFirstPayout: // value for 'firstGrantorFirstPayout'
 *      firstGrantorSecondPayout: // value for 'firstGrantorSecondPayout'
 *      secondGrantorFirstPayout: // value for 'secondGrantorFirstPayout'
 *      secondGrantorSecondPayout: // value for 'secondGrantorSecondPayout'
 *      isTwoGrantorClient: // value for 'isTwoGrantorClient'
 *   },
 * });
 */
export function useEstateTaxScenariosQuery(baseOptions: Apollo.QueryHookOptions<EstateTaxScenariosQuery, EstateTaxScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateTaxScenariosQuery, EstateTaxScenariosQueryVariables>(EstateTaxScenariosDocument, withFetchPolicyContext(options));
      }
export function useEstateTaxScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateTaxScenariosQuery, EstateTaxScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateTaxScenariosQuery, EstateTaxScenariosQueryVariables>(EstateTaxScenariosDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstateTaxScenariosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstateTaxScenariosQuery, EstateTaxScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstateTaxScenariosQuery, EstateTaxScenariosQueryVariables>(EstateTaxScenariosDocument, withFetchPolicyContext(options));
        }
export type EstateTaxScenariosQueryHookResult = ReturnType<typeof useEstateTaxScenariosQuery>;
export type EstateTaxScenariosLazyQueryHookResult = ReturnType<typeof useEstateTaxScenariosLazyQuery>;
export type EstateTaxScenariosSuspenseQueryHookResult = ReturnType<typeof useEstateTaxScenariosSuspenseQuery>;
export type EstateTaxScenariosQueryResult = Apollo.QueryResult<EstateTaxScenariosQuery, EstateTaxScenariosQueryVariables>;
export const UpdateEstateTaxScenariosDocument = gql`
    mutation UpdateEstateTaxScenarios($inputs: [AugmentedUpdateHouseholdInput]!, $clientProfileIDs: [ID!]!) {
  updateHouseholds(inputs: $inputs) {
    ...EstateTaxScenarios_Household
  }
  deleteClientProfilesDsue(profileIDs: $clientProfileIDs)
}
    ${EstateTaxScenarios_HouseholdFragmentDoc}`;
export type UpdateEstateTaxScenariosMutationFn = Apollo.MutationFunction<UpdateEstateTaxScenariosMutation, UpdateEstateTaxScenariosMutationVariables>;

/**
 * __useUpdateEstateTaxScenariosMutation__
 *
 * To run a mutation, you first call `useUpdateEstateTaxScenariosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateTaxScenariosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateTaxScenariosMutation, { data, loading, error }] = useUpdateEstateTaxScenariosMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *      clientProfileIDs: // value for 'clientProfileIDs'
 *   },
 * });
 */
export function useUpdateEstateTaxScenariosMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateTaxScenariosMutation, UpdateEstateTaxScenariosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateTaxScenariosMutation, UpdateEstateTaxScenariosMutationVariables>(UpdateEstateTaxScenariosDocument, options);
      }
export type UpdateEstateTaxScenariosMutationHookResult = ReturnType<typeof useUpdateEstateTaxScenariosMutation>;
export type UpdateEstateTaxScenariosMutationResult = Apollo.MutationResult<UpdateEstateTaxScenariosMutation>;
export type UpdateEstateTaxScenariosMutationOptions = Apollo.BaseMutationOptions<UpdateEstateTaxScenariosMutation, UpdateEstateTaxScenariosMutationVariables>;